import script from "./AssetSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetSearch.vue?vue&type=script&setup=true&lang=ts"

import "./AssetSearch.vue?vue&type=style&index=0&id=09c9884a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09c9884a"]])

export default __exports__